/* eslint-disable no-console */
import * as actionMonitor from '../actions/monitorAction';
import HttpService from './HttpService';
import {
    getUrlExpeditionApi,
    getUrlPhysicalConfirmationApi,
    translate,
    showMessageToastCustom,
    getUrlAEApi
} from '../utils/util';
import { endLoading } from '../actions/loadingAction';

const httpServiceExpedition = new HttpService(getUrlExpeditionApi(window));

const httpServicePhysicalConfirmationV2 = new HttpService(getUrlPhysicalConfirmationApi(window));
export default class MonitorService {
    //Expedição POST motivo Area 
    static getrequestsAnswered(filter, callback) {
        const url = `/api/monitor`;
        return (dispatch) => {
            if (navigator.onLine) {
                httpServiceExpedition.instance.post(url, filter).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionMonitor.setPedidosAtendidos(response.data.data));
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 5000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    //Conferencia Fisica
    static getReceivedVolumes(filter, callback) {
        const url = `/api/monitor/statisticsvolume`;
        return (dispatch) => {
            if (navigator.onLine) {

                httpServicePhysicalConfirmationV2.instance.get(url, { params: filter }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionMonitor.setVolumeRecebidos(response.data.data));
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    dispatch(actionMonitor.setVolumeRecebidos({}));
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 5000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });


            }
        };
    }
}